var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.url)?_c('div',[_c('div',{staticClass:"img-loading"},[_vm._t("img-loading",[_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])],2)]):(_vm.url)?_c('div',[_c('img',{attrs:{"src":_vm.url}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }